@if (loading) {
  <div class="pdf-markup__loading">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
} @else if (errorMessage) {
  <div class="pdf-markup__error">
    <mat-icon>error_outline</mat-icon>
    <p>{{ errorMessage }}</p>
  </div>
} @else {
  <div class="pdf-markup__wrapper" #pdfMarkupWrapper [class.is-fullscreen]="isFullscreen">
    <button
      class="fullscreen-btn"
      mat-icon-button
      type="button"
      [attr.aria-label]="isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'"
      (click)="toggleFullscreen()"
    >
      <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
    </button>

    <div class="pdf-markup__topbar">
      <app-pdf-toolbar
        [currentPage]="currentPage"
        [totalPages]="totalPages"
        (pageChange)="onPageChange($event)"
      ></app-pdf-toolbar>
      <div class="pdf-markup__topbar-divider"></div>
      <app-redline-toolbar
        [activeTool]="redlineActiveTool"
        [lineWidth]="lineWidth"
        [lineWidthDisabled]="activeObjectType === 'textbox'"
        [canUndo]="canUndo"
        [canRedo]="canRedo"
        [isUndoRedoBusy]="isUndoRedoBusy"
        [isDownloading]="isDownloading"
        [isSendingToMips]="isSendingToMips"
        (toolChange)="onRedlineToolChange($event)"
        (lineWidthChange)="onLineWidthChange($event)"
        (zoomIn)="onZoomIn()"
        (zoomOut)="onZoomOut()"
        (rotate)="onRotate()"
        (clearActive)="onClearActive()"
        (clearAll)="onClearAll()"
        (undo)="onUndo()"
        (redo)="onRedo()"
        (download)="onDownload()"
        (sendToMips)="onSendToMips()"
      ></app-redline-toolbar>
    </div>

    <div class="pdf-markup__canvas-container">
      <div class="pdf-markup__canvas-scroller">
        <div class="pdf-markup__canvas-stack">
          <app-pdf-canvas
            [pdfDoc]="pdfDoc"
            [page]="currentPage"
            [scale]="scale"
            [rotation]="rotation"
            (viewportReady)="onViewportReady($event)"
          ></app-pdf-canvas>
          <app-pdf-redline
            [viewport]="activeViewport"
            [baseWidth]="baseWidth"
            [baseHeight]="baseHeight"
            [page]="currentPage"
            [scale]="scale"
            [rotation]="rotation"
            [activeTool]="redlineActiveTool"
            [strokeColor]="strokeColor"
            [fillColor]="fillColor"
            [lineWidth]="lineWidth"
            [initialAnnotations]="initialAnnotations"
            (toolDeactivated)="onToolDeactivated()"
            (annotationsChanged)="onAnnotationsChanged()"
            (annotationDeleted)="onAnnotationDeleted($event)"
            (historyChanged)="onHistoryChanged($event)"
            (undoRedoApplied)="onUndoRedoApplied()"
            (activeObjectTypeChange)="onActiveObjectTypeChange($event)"
          ></app-pdf-redline>
        </div>
      </div>
    </div>
  </div>
}
